import routes from "../constants/routes";
import { lazyLoadRoutes } from "../utils/lazy-loader";

export const essQueryRoutes = [
  {
    path: routes.ess.queryManagement.queryManagement,
    element: lazyLoadRoutes("ess/queryManagement/pages/queryManagement"),
  },
];
